/** Contenido — Propuesta Distribuidora Gran Feria × En Producción con MEM */

export const GRAN_FERIA_PROPOSAL = {
  eyebrow: 'Propuesta de visibilidad',
  title: 'Distribuidora Gran Feria × En Producción con MEM',
  concept: 'Bebidas y despensa al mayor: surtido, ahorro y logística que escala',
  sectionOneTitle: 'El enfoque editorial: abastecimiento al mayor con respaldo logístico',
  intro:
    'Distribuidora Gran Feria es fuerte en agua mineral (todas las presentaciones), refrescos, jugos y víveres — todo al mayor. En el programa comunicamos surtido, precio y la ventaja de surtir sin fricción: envíos gratis en Gran Caracas y despacho a nivel nacional sin costo en pedidos grandes.',
  editorialAxes: [
    {
      title: 'Portafolio de bebidas',
      body:
        'Agua mineral en todas las presentaciones, refrescos y jugos: la línea que más rotan bodegas, kioscos y negocios que reabastecen seguido.',
    },
    {
      title: 'Víveres y ahorro al mayor',
      body:
        'Despensa y víveres en formato mayorista para quien necesita margen y volumen, con mensajes claros de cómo rinde el presupuesto comprando en Gran Feria.',
    },
    {
      title: 'Logística que cierra la venta',
      body:
        'Envíos gratis en Gran Caracas y envío nacional sin costo en grandes pedidos: menos fricción para el cliente que produce o revende.',
    },
  ],
  planExplainSection: {
    overline: 'Estructura de la alianza',
    title: 'Qué incluye cada partida del plan',
    subtitle: '$100 + $60 + $40 = $200 USD/mes',
    body:
      'Antes del resumen en tabla, el detalle de cada frente: frecuencia en streaming, conversación en el programa con María Eugenia Moreno y refuerzo editorial en TNO Digest para búsquedas locales (distribuidora, bebidas al mayor, abastecimiento).',
  },
  planExplainCards: [
    {
      service: 'Streaming',
      priceUsd: 100,
      icon: 'liveTv',
      details: [
        '12 impactos diarios (360 al mes) en streaming en la señal 24/7 de TNO Network.',
        'Spots alineados a «Ofertas de la semana»: agua, refrescos, jugos, víveres y beneficios de envío al mayor.',
      ],
      benefit:
        'Mantiene el nombre de Distribuidora Gran Feria en rotación constante: recordación, confianza y empuje al pedido mayorista.',
    },
    {
      service: 'Segmento en programa',
      priceUsd: 60,
      icon: 'recordVoiceOver',
      details: [
        'Mención de marca y recomendación directa en cada emisión de En Producción con MEM.',
        'Lenguaje cercano: surtido de bebidas, víveres al mayor y logística (Gran Caracas / pedidos grandes a nivel nacional).',
      ],
      benefit:
        'Humaniza la distribuidora: no es solo precio, es quién te surte bebidas y despensa con respaldo de entrega.',
    },
    {
      service: 'Dominio SEO (TNO Digest)',
      priceUsd: 40,
      icon: 'menuBook',
      details: [
        '1 artículo quincenal (2 al mes) en el ecosistema editorial TNO Digest.',
        'Temas guía: compra inteligente al mayor, abastecer bodega o negocio, agua y bebidas para reventa.',
      ],
      benefit:
        'Cuando alguien busque distribuidora, bebidas al mayor o abastecimiento en Caracas, el contenido apunta a Gran Feria y a la acción.',
    },
  ],
  planTableHeading: 'Resumen de inversión',
  planTitle: 'Desglose de inversión mensual (Plan Gran Feria)',
  planRows: [
    {
      service: 'Streaming',
      detail:
        '12 impactos diarios (360 al mes) en streaming en la señal 24/7 de TNO. Spots enfocados en ofertas de agua, refrescos, jugos, víveres y compra al mayor.',
      amount: '$100',
    },
    {
      service: 'Segmento en programa',
      detail:
        'Mención de marca y recomendación directa en cada emisión de En Producción con MEM (surtido y logística de Gran Feria).',
      amount: '$60',
    },
    {
      service: 'Dominio SEO (TNO Digest)',
      detail:
        '1 artículo quincenal (2 al mes). Temas: «Guía para abastecer tu negocio al mayor» o «Agua, refrescos y víveres: cómo elegir distribuidor en Caracas».',
      amount: '$40',
    },
  ],
  planTotalLabel: 'Plan eficiencia y alcance',
  planTotalAmount: '$200',
  materialsTitle: 'Material para el programa y rotativa',
  radioScriptTitle: 'Para la rotativa (micro de ofertas)',
  radioScript:
    '¿Reabasteces tu negocio o tu hogar? En Distribuidora Gran Feria tienes agua mineral en todas las presentaciones, refrescos, jugos y víveres — todo al mayor. Envíos gratis en Gran Caracas y a nivel nacional sin costo en grandes pedidos. ¡Pide y compruébalo! Un aliado de En Producción con MEM, por TNO Network.',
  programTitle: 'Para el programa',
  programBullets: [
    'El «dato» de Mem: producto estrella del día (agua, refresco, jugo o víveres). «Para los que están produciendo hoy, los amigos de la Gran Feria surten al mayor y te facilitan el envío cuando el pedido lo amerita».',
    'Visuales en pantalla: fotos o videos rápidos (tipo Reels) del surtido de bebidas y despensa mientras se hace la mención, para reconocer marca y categorías.',
  ],
  whatsappPhone: '04141355751',
  whatsappLabel: 'WhatsApp 0414-1355751',
  ctaBody:
    'Escríbenos por WhatsApp; referencia esta propuesta y coordinamos el siguiente paso con el equipo comercial.',
  whyTitle: 'Por qué esta propuesta funciona por $200',
  whyPoints: [
    {
      title: 'Frecuencia alta',
      body:
        '12 veces al día es el estándar necesario para que el nombre se quede en la mente de quien compra al mayor o reabastece seguido.',
    },
    {
      title: 'Autoridad en Google',
      body:
        'Los artículos en TNO Digest capturan búsquedas de distribuidora, bebidas al mayor y abastecimiento en Caracas y alrededores.',
    },
    {
      title: 'Conversión directa',
      body:
        'El programa de Mem traduce surtido (agua, refrescos, jugos, víveres), precio mayorista y logística sin costo en pedidos grandes en una invitación clara a pedir.',
    },
  ],
};
